import { Close } from 'pcln-icons';
import React from 'react';
import { ChipContent } from '../ChipContent/ChipContent';
import { ChipInput } from '../ChipInput';
import { ChipLabel } from '../ChipLabel';
const getTitle = ({
  disabled,
  actionTitle
}) => `${actionTitle}${disabled ? ' disabled' : ''}`;
/**
 * @public
 */
export function FilterChip({
  id,
  name,
  color = 'primary',
  disabled,
  selected,
  children,
  onClick,
  label,
  showActionIcon,
  actionTitle = 'Close',
  value,
  variation = 'outline',
  ...props
}) {
  return React.createElement(ChipLabel, {
    htmlFor: id,
    width: 'auto',
    color: color,
    ...props
  }, React.createElement(ChipInput, {
    type: 'checkbox',
    role: 'checkbox',
    id: id,
    name: name,
    "data-testid": id,
    disabled: disabled,
    checked: selected,
    onChange: onClick,
    value: value
  }), React.createElement(ChipContent, {
    label: label,
    disabled: disabled,
    selected: selected,
    action: showActionIcon && {
      Icon: Close,
      title: getTitle({
        disabled,
        actionTitle
      })
    },
    variation: variation,
    color: color,
    ...props
  }, children));
}
FilterChip.displayName = 'FilterChip';